import { connect } from 'react-redux';
import { compose, shouldUpdate, withState, withHandlers } from 'recompose';

import { getShops } from '../../../shops/reducers';
import withLoading from '../../../../common/withLoading';

const mapStateToProps = state => ({
  users: getShops(state),
  showLoading: state.admin.isFetching,
});

export default compose(
  connect(mapStateToProps),
  shouldUpdate(props => !props.users.length),
  withLoading,
  withState('expanded', 'setExpanded', {}),
  withHandlers({
    onExpand: props => viewIndex => () => {
      props.setExpanded({ [viewIndex]: !props.expanded[viewIndex] });
    },
  })
);
